// Boston University's undergraduate majors (lane 2, #2745). Read on 2026-10-01 from
// BU's official Degree Programs index (bu.edu/academics/degree-programs), which links
// each program's Bulletin page; every BA, BS, BFA and BM link is kept and grouped by the
// school its Bulletin page sits under. A program indexed under two names is kept once.
// Metropolitan College's bachelor's programs (part-time and evening, not open to
// first-year applicants) are left out, as are dual-degree (BA-to-MA and similar),
// minor and graduate links. Ampersands are written as "and".
const majors = {
    "slug": "boston-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major on Boston University's official Degree Programs index, grouped by the school that offers it, with the degree. Combined bachelor's-to-master's programs, minors and Metropolitan College's part-time programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "African American and Black Diaspora Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Ancient Greek and Latin",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology and Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology with a Specialization in Anthropology, Health and Medicine",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology with a Specialization in Biological Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology with a Specialization in Sociocultural Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Archaeological and Environmental Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Architectural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy and Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology with a Specialization in Behavioral Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology with a Specialization in Biodiversity, Conservation and Global Change Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology with a Specialization in Cell Biology, Molecular Biology and Genetics",
                    "degree": "B.A."
                },
                {
                    "name": "Biology with a Specialization in Neurobiology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry and Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry: Chemical Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry: Materials and Nanoscience",
                    "degree": "B.A."
                },
                {
                    "name": "Chinese Language and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Cinema and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classics and Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Classics and Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Classics and Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science and Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics and Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Analysis and Policy",
                    "degree": "B.A."
                },
                {
                    "name": "European Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French and Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "German Language and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Greek, Ancient",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History of Art and Architecture",
                    "degree": "B.A."
                },
                {
                    "name": "Holocaust, Genocide and Human Rights Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Independent Major",
                    "degree": "B.A."
                },
                {
                    "name": "International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Italian and Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese Language and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese and Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Korean Language and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and African Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics and Speech, Language and Hearing Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Marine Science",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics (includes Statistics)",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics and Mathematics Education",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics and Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics and Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Middle East and North Africa Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Middle Eastern and South Asian Languages and Literatures",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy and Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy and Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy and Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy and Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy and Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics and Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Russian Language and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Science Education",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish and Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics and Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Teaching of Chemistry",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Faculty of Computing and Data Sciences",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "Data Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Communication",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "B.S."
                },
                {
                    "name": "Film and Television",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.S."
                },
                {
                    "name": "Media Science",
                    "degree": "B.S."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art Education",
                    "degree": "B.F.A."
                },
                {
                    "name": "Composition and Music Theory",
                    "degree": "B.M."
                },
                {
                    "name": "Costume Design and Production",
                    "degree": "B.F.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Lighting Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Painting",
                    "degree": "B.F.A."
                },
                {
                    "name": "Printmaking",
                    "degree": "B.F.A."
                },
                {
                    "name": "Scene Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Sculpture",
                    "degree": "B.F.A."
                },
                {
                    "name": "Sound Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Stage Management",
                    "degree": "B.F.A."
                },
                {
                    "name": "Technical Production",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Arts, Design and Production",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Arts, Performance",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "School of Hospitality Administration",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "Hospitality Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality and Communication",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Questrom School of Business",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Sargent College of Health and Rehabilitation Sciences",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "Behavior and Health",
                    "degree": "B.S."
                },
                {
                    "name": "Health Science",
                    "degree": "B.S."
                },
                {
                    "name": "Human Physiology",
                    "degree": "B.S."
                },
                {
                    "name": "Linguistics and Speech, Language and Hearing Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Wheelock College of Education and Human Development",
            "source": {
                "label": "Boston University, Degree Programs",
                "url": "https://www.bu.edu/academics/degree-programs/"
            },
            "majors": [
                {
                    "name": "Bilingual Education/Teaching English to Speakers of Other Languages",
                    "degree": "B.S."
                },
                {
                    "name": "Deaf Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Education and Human Development",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "English Education",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics Education",
                    "degree": "B.S."
                },
                {
                    "name": "Modern Foreign Language Education",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education",
                    "degree": "B.S."
                },
                {
                    "name": "Social Studies Education",
                    "degree": "B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
